<template>
  <div class="row full-width full-height">
    <div
      :id="talkjs.INBOX_ID"
      class="col-sm-12 row talkjs-container"
    />
  </div>
</template>

<script setup>
import { inject, onMounted } from 'vue'

import { talkjsKey } from '@/keys'

const talkjs = inject(talkjsKey)

// we need to create here because ids used on talkjs need to be present on the DOM
onMounted(() => {
  talkjs.createInbox()
})
</script>
